<template>
  <div class="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
    <div class="max-w-md w-full space-y-8">
      <!-- Заголовок -->
      <div class="text-center">
        <h2 class="mt-6 text-3xl font-bold text-gray-900">
          Вход в систему
        </h2>
        <p class="mt-2 text-sm text-gray-600">
          Dashboard System
        </p>
      </div>

      <!-- Форма входа -->
      <form @submit.prevent="handleLogin" class="mt-8 space-y-6">
        <div class="space-y-4">
          <!-- Username -->
          <div>
            <label for="username" class="form-label">
              Имя пользователя
            </label>
            <input
              id="username"
              v-model="form.username"
              type="text"
              required
              class="form-input"
              :class="{ 'border-danger-300 focus:border-danger-500 focus:ring-danger-500': loginError }"
              placeholder="Введите имя пользователя"
              :disabled="isLoading"
            />
          </div>

          <!-- Password -->
          <div>
            <label for="password" class="form-label">
              Пароль
            </label>
            <input
              id="password"
              v-model="form.password"
              type="password"
              required
              class="form-input"
              :class="{ 'border-danger-300 focus:border-danger-500 focus:ring-danger-500': loginError }"
              placeholder="Введите пароль"
              :disabled="isLoading"
            />
          </div>
        </div>

        <!-- Ошибка входа -->
        <div v-if="loginError" class="form-error">
          {{ loginError }}
        </div>

        <!-- Кнопка входа -->
        <div>
          <button
            type="submit"
            class="btn-primary w-full btn-lg"
            :disabled="isLoading"
          >
            <div v-if="isLoading" class="loading-spinner mr-2"></div>
            {{ isLoading ? 'Вход...' : 'Войти' }}
          </button>
        </div>
      </form>

      <!-- Информация для разработки -->
      <div v-if="isDev" class="mt-6 p-4 bg-blue-50 rounded-lg border border-blue-200">
        <h3 class="text-sm font-medium text-blue-800 mb-2">
          Данные для входа (разработка):
        </h3>
        <div class="text-sm text-blue-700 space-y-1">
          <p><strong>Логин:</strong> admin</p>
          <p><strong>Пароль:</strong> admin123</p>
        </div>
        <button
          @click="fillDemoCredentials"
          class="mt-2 text-sm text-blue-600 hover:text-blue-800 underline"
          type="button"
        >
          Заполнить автоматически
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { reactive, ref, onMounted } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { useAuthStore } from '@/stores/auth'

const router = useRouter()
const route = useRoute()
const authStore = useAuthStore()

// Состояние формы
const form = reactive({
  username: '',
  password: ''
})

// Вычисляемые свойства
const isLoading = ref(false)
const loginError = ref('')
const isDev = import.meta.env.DEV

// Обработка входа
const handleLogin = async () => {
  loginError.value = ''
  isLoading.value = true

  try {
    const success = await authStore.login({
      username: form.username,
      password: form.password
    })

    if (success) {
      // Перенаправляем на запрошенную страницу или дэшборд
      const redirectPath = route.query.redirect || '/dashboard'
      await router.push(redirectPath)
    } else {
      loginError.value = authStore.loginError
    }
  } catch (error) {
    loginError.value = 'Произошла неожиданная ошибка'
    console.error('Ошибка входа:', error)
  } finally {
    isLoading.value = false
  }
}

// Заполнение демо данных для разработки
const fillDemoCredentials = () => {
  form.username = 'admin'
  form.password = 'admin123'
}

// Автоматическое заполнение в dev режиме
onMounted(() => {
  if (isDev) {
    fillDemoCredentials()
  }
})
</script>